import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-31984ba2"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "check-box-icon"
}

import { computed } from 'vue';
import IconComponent from '../components/icon/IconComponent.vue';
import Icon from '../components/icon/Icon';


export default /*#__PURE__*/_defineComponent({
  __name: 'CheckBox',
  props: {
    state: { type: Boolean }
  },
  setup(__props: any) {

const props = __props as {
  state: boolean;
}



const checkBoxBackground = computed(() => {
  return {
    'check-box-background-complete': props.state,
    'check-box-background-incomplete': !props.state
  };
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["check-box-body", _unref(checkBoxBackground)])
  }, [
    (props.state)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createVNode(IconComponent, {
            icon: _unref(Icon).WHITE_CHECK
          }, null, 8, ["icon"])
        ]))
      : _createCommentVNode("", true)
  ], 2))
}
}

})